export const locale = {
    lang: 'en',
    data: {
        NOTIFICATIONS: {
            SIDEBAR: {
                TITLE: 'Notifications',
            },
        },
    },
};
